import { isUserLicensed } from "@ado/user-license-service";
import { createCountryCodeProvider } from "@ado/location-library";

import { UserLicenseStatusChecker } from "./UserLicenseStatusChecker";

export class DefaultUserLicenseStatusChecker
	implements UserLicenseStatusChecker
{
	async checkIfLicensed(productCode: string | undefined): Promise<boolean> {
		if (productCode === undefined) {
			return Promise.resolve(false);
		}

		const countryCode = createCountryCodeProvider().provideCountryCode();

		if (countryCode === undefined) {
			return Promise.resolve(false);
		}

		return isUserLicensed(productCode, countryCode, true);
	}
}
